module.exports = __webpack_public_path__ + "static/media/instructivor4.97bb61b9.png";